import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function AuthGuard({ children }: { children: ReactNode }) {
  const auth = useAuth()
  const location = useLocation()

  if (auth.status === 'loading') {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0b1226] t-primary">
        <div className="flex items-center gap-3 t-muted">
          <Loader2 size={20} className="animate-spin text-toga-400" />
          <span>Cargando…</span>
        </div>
      </div>
    )
  }

  if (auth.status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
